export const bannerEvent = {
    event: "offer_banner_rto"
};
